import { menuSubtitleBlock, menu } from "../services/variables.js";

function showSmallMenu(e, smallMenuShow, smallMenuHeight, overflowMenuScroll) {
	if (window.innerWidth <= 575) {
		if (e.nextSibling.classList.contains(smallMenuShow)) {
			e.nextSibling.classList.remove(smallMenuShow);
			e.nextSibling.classList.remove(smallMenuHeight);
		} else {
			menuSubtitleBlock.forEach((block) => {
				block.classList.remove(smallMenuShow);
				block.classList.remove(smallMenuHeight);
			});
			e.nextSibling.classList.add(smallMenuShow);
			e.nextSibling.classList.add(smallMenuHeight);
		}
		menu.classList.add(overflowMenuScroll);
	}
}

export default showSmallMenu;
